import { ASSETS, SLOGANS } from "@/data/content";
import { t } from "@/data/texts";
import { img } from "@/data/images";
import { Reveal, FliesSlogan } from "@/components/effects/Effects";

export default function ChairShowcase() {
  return (
    <section className="relative bg-[#060505] border-b border-white/10" data-testid="chair-section">
      <div className="max-w-6xl mx-auto px-5 py-20 lg:py-28">
        <Reveal>
          <p className="text-center font-head text-2xl sm:text-3xl text-neutral-100 mb-10 vhs-glitch">
            <FliesSlogan text={`„${t("chair.slogan", SLOGANS[1])}"`} />
          </p>
        </Reveal>
        <Reveal delay={120}>
          <div className="border border-white/10 overflow-hidden">
            <img
              src={img("chair", ASSETS.chair)}
              alt="Ošetřovna — HUBERT"
              loading="lazy"
              className="w-full h-auto object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
